import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ChangeDigitalSignatureEventType } from '../change-digital-signature.event.type';
import { Subscription } from 'rxjs/Subscription';
import { TweenMax, Quint, Power2, Sine } from 'gsap';
import { ChangeDigitalSignatureService } from '../change-digital-signature.service';
import { ChangeDigitalSignatureMessage } from '../model/change-digital-signature-message';
import { Auth } from '../../../autentication/Auth';
import { Question } from '../../../autentication/models/question';
import { EventTypes } from '../../../shared/EventTypes';
import { AnswerToken } from '../../../shared/models/answer-token.model';

@Component({
	selector: 'app-security-check-signature',
	templateUrl: './security-check-signature.component.html',
	styleUrls: ['./security-check-signature.component.styl'],
	encapsulation: ViewEncapsulation.None,
	providers: [ChangeDigitalSignatureMessage]
})
export class SecurityCheckComponent implements OnInit, OnDestroy {

	public submited: boolean;
	public view = '[data-component="security-check-signature"]';
	public active = false;
	public subscription: Subscription;
	public form: FormGroup;
	public questions: Array<Question> = [];
	public activeQuestion: Question = new Question();
	public questionIndex = 0;
	public loading: boolean;
	public answerError: boolean;
	public answerErrorMessage: string;
	public done: boolean;
	public canSend = false;
	public message = undefined;
	public questionError = false;
	public correctQuestionsAnswer: AnswerToken[] = []

	constructor(private formBuilder: FormBuilder, private changeDigitalSignatureMessage: ChangeDigitalSignatureMessage,
		private changeDigitalSignatureService: ChangeDigitalSignatureService) {
			this.form = formBuilder.group({
				'answer': [null, Validators.required]
			});
	}

	ngOnInit() {
		AppEventDispatcher.listen(ChangeDigitalSignatureEventType.LOGIN.SECURITY_CHECK, (data: any) => {
			this.preload(true);

			this.changeDigitalSignatureService.getSecurityQuestions(Auth.getInstance().getUser().cpf).subscribe((questions: Array<Question>) => {
				this.questions = questions;
				this.activeQuestion = questions[this.questionIndex];

				this.setQuestionMask();


				if (data.show) {
					this.active = true;

					const interval = setInterval(() => {
						if ($(this.view).length > 0) {
							AppEventDispatcher.dispatch(ChangeDigitalSignatureEventType.AUTH_MESSAGE.LOAD_COMPLETE, null);
							this.show(data);
							clearInterval(interval);
						}
					}, 10);

				}

				this.preload(false);
			}, error => {
				this.preload(false);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				AppEventDispatcher.dispatch(ChangeDigitalSignatureEventType.AUTH_MESSAGE.LOAD_COMPLETE, { error: true });
			});

		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ChangeDigitalSignatureEventType.LOGIN.SECURITY_CHECK);
	}

	show(data) {
		TweenMax.to(this.view, .8, {
			delay: data.delay, left: 0, ease: Quint.easeOut, onComplete: () => {
				TweenMax.to(this.view + ' .question-step', .8, {left: 0, ease: Quint.easeOut} );
			}
		});
	}

	setQuestionMask() {
		this.activeQuestion.mask = [];
		if (this.activeQuestion.type === 1) {
			for (let i = 0; i < this.activeQuestion.size; i++) {
				this.activeQuestion.mask.push(/./);
			}
		} else if (this.activeQuestion.type === 2) {
			for (let i = 0; i < this.activeQuestion.integers; i++) {
				this.activeQuestion.mask.push(/\d/);
			}
		} else if (this.activeQuestion.type === 3) {
			this.activeQuestion.mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
		}

	}

	answerChange(event) {

		if (this.form.controls.answer.valid) {
			this.canSend = true;
		} else {
			this.canSend = false;
		}

	}

	sendAnswer() {

		if (this.canSend) {
			this.submited = true;

			if (this.form.valid && !this.loading && !this.done) {
				this.loading = true;
				this.submited = false;
				this.answerError = false;

				this.sendToService();

			}
		}

	}

	sendToService() {
		this.preload(true);
		const cpf = Auth.getInstance().getUser().cpf;
		this.changeDigitalSignatureService.sendAnswer(cpf, this.activeQuestion, this.form.controls.answer.value).subscribe((data: any) => {

			if (data.Retorno && data.Sucesso) {
				this.correctQuestionsAnswer.push({ id: this.activeQuestion.code, descricao: this.form.controls.answer.value });
				this.loading = false;
				this.canSend = false;
				this.questionError = false;

				if (this.questionIndex < (this.questions.length - 1)) {

					TweenMax.to(this.view + ' .question-step', .8, {
						left: '-100%', ease: Quint.easeOut, onComplete: () => {
							this.questionIndex++;
							this.activeQuestion = this.questions[this.questionIndex];

							this.setQuestionMask();
							this.form.controls.answer.setValue('');
							this.form.controls.answer.updateValueAndValidity();

							$(this.view + ' .question-step').css('left', '100%');
							TweenMax.to(this.view + ' .question-step', .8, {
								left: 0, ease: Quint.easeOut, onComplete: () => {
								}
							});

							this.preload(false);

						}
					});

				} else {

					this.questionsDone();

				}

			}

		}, (error: any) => {

			this.loading = false;
			this.canSend = true;

			if (error.error.Mensagem && error.status !== 500) {
				this.questionError = true;
				TweenMax.to(this.view + ' .question-step', .8, {
					left: '-100%', ease: Quint.easeOut, onComplete: () => {
						$(this.view + ' .question-step').css('left', '100%');
					}
				});
				this.form.controls.answer.setValue('');
				AppEventDispatcher.dispatch(ChangeDigitalSignatureEventType.LOGIN.SECURITY_CHECK, {show: true});
				this.questionIndex = 0;

			}else {
				this.preload(false);
			}

		});
	}

	questionsDone() {
		this.done = true;
		Auth.setSecurityQuestions(this.correctQuestionsAnswer);
		this.changeDigitalSignatureService.getSmsCode(Auth.getInstance().getUser().cpf).subscribe(sms => {
			this.hide();
			this.preload(false);
			AppEventDispatcher.dispatch(ChangeDigitalSignatureEventType.LOGIN.SMS_VALIDATION, { show: true, sms: sms });
		});

	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="reset"] .content', show: active, delay: delay });
	}

	hide() {
		$(this.view).hide();
		TweenMax.to(this.view, .8, {
			left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}
		});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-digital-signature/security-check-signature/security-check-signature.component.ts